module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [(!!_vm.fileUrl && _vm.fileUrl !== _vm.addImg) ? _c('video', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.fileUrl
    }
  }, [_vm._v("\n\t\t\t\tYour browser does not support the video tag.\n\t\t\t")]) : _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.fileUrl,
      "fit": "cover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('a', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "file",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.btnText) + "\n    \t\t\t"), _c('input', {
    attrs: {
      "id": "file",
      "type": "file",
      "accept": "video/mp4, video/rm, video/rmvb, video/mov, video/m4v, video/avi, video/flv, video/wmv"
    },
    on: {
      "change": function($event) {
        return _vm.uploadFile($event)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticStyle: {
      "display": "block",
      "margin-left": "50px"
    }
  }, [_vm._v("最大20M")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe4b42a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UploadFileVideo.vue
// module id = 720
// module chunks = 1